import { AppPermission } from '../types';

export const PermissionRoutes: { [key: string]: string } = {
  STATUS: '/way-status',
};

export const RoutePermissions: { [key: string]: AppPermission } = {
  '/way-status': 'STATUS',
};
